// source: pbtypes/gen/skills/control_scheme_params.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var pbtypes_gen_skills_beacon_steering_control_scheme_params_pb = require('../../../pbtypes/gen/skills/beacon_steering_control_scheme_params_pb.js');
goog.object.extend(proto, pbtypes_gen_skills_beacon_steering_control_scheme_params_pb);
var pbtypes_gen_skills_gimbal_pitch_handler_params_pb = require('../../../pbtypes/gen/skills/gimbal_pitch_handler_params_pb.js');
goog.object.extend(proto, pbtypes_gen_skills_gimbal_pitch_handler_params_pb);
var pbtypes_gen_skills_goto_point_handler_params_pb = require('../../../pbtypes/gen/skills/goto_point_handler_params_pb.js');
goog.object.extend(proto, pbtypes_gen_skills_goto_point_handler_params_pb);
var pbtypes_gen_skills_hover_control_scheme_params_pb = require('../../../pbtypes/gen/skills/hover_control_scheme_params_pb.js');
goog.object.extend(proto, pbtypes_gen_skills_hover_control_scheme_params_pb);
var pbtypes_gen_skills_joysticks_control_scheme_params_pb = require('../../../pbtypes/gen/skills/joysticks_control_scheme_params_pb.js');
goog.object.extend(proto, pbtypes_gen_skills_joysticks_control_scheme_params_pb);
var pbtypes_gen_skills_movement_tracking_control_scheme_params_pb = require('../../../pbtypes/gen/skills/movement_tracking_control_scheme_params_pb.js');
goog.object.extend(proto, pbtypes_gen_skills_movement_tracking_control_scheme_params_pb);
var pbtypes_gen_skills_pan_tilt_handler_params_pb = require('../../../pbtypes/gen/skills/pan_tilt_handler_params_pb.js');
goog.object.extend(proto, pbtypes_gen_skills_pan_tilt_handler_params_pb);
var pbtypes_gen_skills_standard_tracking_control_scheme_params_pb = require('../../../pbtypes/gen/skills/standard_tracking_control_scheme_params_pb.js');
goog.object.extend(proto, pbtypes_gen_skills_standard_tracking_control_scheme_params_pb);
var pbtypes_gen_skills_steering_control_scheme_params_pb = require('../../../pbtypes/gen/skills/steering_control_scheme_params_pb.js');
goog.object.extend(proto, pbtypes_gen_skills_steering_control_scheme_params_pb);
var pbtypes_gen_skills_steering_joystick_handler_params_pb = require('../../../pbtypes/gen/skills/steering_joystick_handler_params_pb.js');
goog.object.extend(proto, pbtypes_gen_skills_steering_joystick_handler_params_pb);
var pbtypes_gen_skills_tap_to_fly_control_scheme_params_pb = require('../../../pbtypes/gen/skills/tap_to_fly_control_scheme_params_pb.js');
goog.object.extend(proto, pbtypes_gen_skills_tap_to_fly_control_scheme_params_pb);
goog.exportSymbol('proto.skills.ControlSchemeParams', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.ControlSchemeParams = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.ControlSchemeParams, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.ControlSchemeParams.displayName = 'proto.skills.ControlSchemeParams';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.ControlSchemeParams.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.ControlSchemeParams.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.ControlSchemeParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.ControlSchemeParams.toObject = function(includeInstance, msg) {
  var f, obj = {
version: jspb.Message.getFieldWithDefault(msg, 1, 0),
gimbalPitchHandler: (f = msg.getGimbalPitchHandler()) && pbtypes_gen_skills_gimbal_pitch_handler_params_pb.GimbalPitchHandlerParams.toObject(includeInstance, f),
panTiltHandler: (f = msg.getPanTiltHandler()) && pbtypes_gen_skills_pan_tilt_handler_params_pb.PanTiltHandlerParams.toObject(includeInstance, f),
steeringJoystickHandler: (f = msg.getSteeringJoystickHandler()) && pbtypes_gen_skills_steering_joystick_handler_params_pb.SteeringJoystickHandlerParams.toObject(includeInstance, f),
gotoPointHandler: (f = msg.getGotoPointHandler()) && pbtypes_gen_skills_goto_point_handler_params_pb.GotoPointHandlerParams.toObject(includeInstance, f),
joysticksControlScheme: (f = msg.getJoysticksControlScheme()) && pbtypes_gen_skills_joysticks_control_scheme_params_pb.JoysticksControlSchemeParams.toObject(includeInstance, f),
steeringControlScheme: (f = msg.getSteeringControlScheme()) && pbtypes_gen_skills_steering_control_scheme_params_pb.SteeringControlSchemeParams.toObject(includeInstance, f),
tapToFlyControlScheme: (f = msg.getTapToFlyControlScheme()) && pbtypes_gen_skills_tap_to_fly_control_scheme_params_pb.TapToFlyControlSchemeParams.toObject(includeInstance, f),
standardTrackingControlScheme: (f = msg.getStandardTrackingControlScheme()) && pbtypes_gen_skills_standard_tracking_control_scheme_params_pb.StandardTrackingControlSchemeParams.toObject(includeInstance, f),
movementTrackingControlScheme: (f = msg.getMovementTrackingControlScheme()) && pbtypes_gen_skills_movement_tracking_control_scheme_params_pb.MovementTrackingControlSchemeParams.toObject(includeInstance, f),
hoverControlScheme: (f = msg.getHoverControlScheme()) && pbtypes_gen_skills_hover_control_scheme_params_pb.HoverControlSchemeParams.toObject(includeInstance, f),
beaconSteeringControlScheme: (f = msg.getBeaconSteeringControlScheme()) && pbtypes_gen_skills_beacon_steering_control_scheme_params_pb.BeaconSteeringControlSchemeParams.toObject(includeInstance, f),
tripodTrackingControlScheme: (f = msg.getTripodTrackingControlScheme()) && pbtypes_gen_skills_movement_tracking_control_scheme_params_pb.MovementTrackingControlSchemeParams.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.ControlSchemeParams}
 */
proto.skills.ControlSchemeParams.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.ControlSchemeParams;
  return proto.skills.ControlSchemeParams.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.ControlSchemeParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.ControlSchemeParams}
 */
proto.skills.ControlSchemeParams.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setVersion(value);
      break;
    case 2:
      var value = new pbtypes_gen_skills_gimbal_pitch_handler_params_pb.GimbalPitchHandlerParams;
      reader.readMessage(value,pbtypes_gen_skills_gimbal_pitch_handler_params_pb.GimbalPitchHandlerParams.deserializeBinaryFromReader);
      msg.setGimbalPitchHandler(value);
      break;
    case 3:
      var value = new pbtypes_gen_skills_pan_tilt_handler_params_pb.PanTiltHandlerParams;
      reader.readMessage(value,pbtypes_gen_skills_pan_tilt_handler_params_pb.PanTiltHandlerParams.deserializeBinaryFromReader);
      msg.setPanTiltHandler(value);
      break;
    case 4:
      var value = new pbtypes_gen_skills_steering_joystick_handler_params_pb.SteeringJoystickHandlerParams;
      reader.readMessage(value,pbtypes_gen_skills_steering_joystick_handler_params_pb.SteeringJoystickHandlerParams.deserializeBinaryFromReader);
      msg.setSteeringJoystickHandler(value);
      break;
    case 5:
      var value = new pbtypes_gen_skills_goto_point_handler_params_pb.GotoPointHandlerParams;
      reader.readMessage(value,pbtypes_gen_skills_goto_point_handler_params_pb.GotoPointHandlerParams.deserializeBinaryFromReader);
      msg.setGotoPointHandler(value);
      break;
    case 10:
      var value = new pbtypes_gen_skills_joysticks_control_scheme_params_pb.JoysticksControlSchemeParams;
      reader.readMessage(value,pbtypes_gen_skills_joysticks_control_scheme_params_pb.JoysticksControlSchemeParams.deserializeBinaryFromReader);
      msg.setJoysticksControlScheme(value);
      break;
    case 11:
      var value = new pbtypes_gen_skills_steering_control_scheme_params_pb.SteeringControlSchemeParams;
      reader.readMessage(value,pbtypes_gen_skills_steering_control_scheme_params_pb.SteeringControlSchemeParams.deserializeBinaryFromReader);
      msg.setSteeringControlScheme(value);
      break;
    case 12:
      var value = new pbtypes_gen_skills_tap_to_fly_control_scheme_params_pb.TapToFlyControlSchemeParams;
      reader.readMessage(value,pbtypes_gen_skills_tap_to_fly_control_scheme_params_pb.TapToFlyControlSchemeParams.deserializeBinaryFromReader);
      msg.setTapToFlyControlScheme(value);
      break;
    case 13:
      var value = new pbtypes_gen_skills_standard_tracking_control_scheme_params_pb.StandardTrackingControlSchemeParams;
      reader.readMessage(value,pbtypes_gen_skills_standard_tracking_control_scheme_params_pb.StandardTrackingControlSchemeParams.deserializeBinaryFromReader);
      msg.setStandardTrackingControlScheme(value);
      break;
    case 14:
      var value = new pbtypes_gen_skills_movement_tracking_control_scheme_params_pb.MovementTrackingControlSchemeParams;
      reader.readMessage(value,pbtypes_gen_skills_movement_tracking_control_scheme_params_pb.MovementTrackingControlSchemeParams.deserializeBinaryFromReader);
      msg.setMovementTrackingControlScheme(value);
      break;
    case 15:
      var value = new pbtypes_gen_skills_hover_control_scheme_params_pb.HoverControlSchemeParams;
      reader.readMessage(value,pbtypes_gen_skills_hover_control_scheme_params_pb.HoverControlSchemeParams.deserializeBinaryFromReader);
      msg.setHoverControlScheme(value);
      break;
    case 16:
      var value = new pbtypes_gen_skills_beacon_steering_control_scheme_params_pb.BeaconSteeringControlSchemeParams;
      reader.readMessage(value,pbtypes_gen_skills_beacon_steering_control_scheme_params_pb.BeaconSteeringControlSchemeParams.deserializeBinaryFromReader);
      msg.setBeaconSteeringControlScheme(value);
      break;
    case 17:
      var value = new pbtypes_gen_skills_movement_tracking_control_scheme_params_pb.MovementTrackingControlSchemeParams;
      reader.readMessage(value,pbtypes_gen_skills_movement_tracking_control_scheme_params_pb.MovementTrackingControlSchemeParams.deserializeBinaryFromReader);
      msg.setTripodTrackingControlScheme(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.ControlSchemeParams.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.ControlSchemeParams.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.ControlSchemeParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.ControlSchemeParams.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersion();
  if (f !== 0) {
    writer.writeSint32(
      1,
      f
    );
  }
  f = message.getGimbalPitchHandler();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_skills_gimbal_pitch_handler_params_pb.GimbalPitchHandlerParams.serializeBinaryToWriter
    );
  }
  f = message.getPanTiltHandler();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_gen_skills_pan_tilt_handler_params_pb.PanTiltHandlerParams.serializeBinaryToWriter
    );
  }
  f = message.getSteeringJoystickHandler();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      pbtypes_gen_skills_steering_joystick_handler_params_pb.SteeringJoystickHandlerParams.serializeBinaryToWriter
    );
  }
  f = message.getGotoPointHandler();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      pbtypes_gen_skills_goto_point_handler_params_pb.GotoPointHandlerParams.serializeBinaryToWriter
    );
  }
  f = message.getJoysticksControlScheme();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      pbtypes_gen_skills_joysticks_control_scheme_params_pb.JoysticksControlSchemeParams.serializeBinaryToWriter
    );
  }
  f = message.getSteeringControlScheme();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      pbtypes_gen_skills_steering_control_scheme_params_pb.SteeringControlSchemeParams.serializeBinaryToWriter
    );
  }
  f = message.getTapToFlyControlScheme();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      pbtypes_gen_skills_tap_to_fly_control_scheme_params_pb.TapToFlyControlSchemeParams.serializeBinaryToWriter
    );
  }
  f = message.getStandardTrackingControlScheme();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      pbtypes_gen_skills_standard_tracking_control_scheme_params_pb.StandardTrackingControlSchemeParams.serializeBinaryToWriter
    );
  }
  f = message.getMovementTrackingControlScheme();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      pbtypes_gen_skills_movement_tracking_control_scheme_params_pb.MovementTrackingControlSchemeParams.serializeBinaryToWriter
    );
  }
  f = message.getHoverControlScheme();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      pbtypes_gen_skills_hover_control_scheme_params_pb.HoverControlSchemeParams.serializeBinaryToWriter
    );
  }
  f = message.getBeaconSteeringControlScheme();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      pbtypes_gen_skills_beacon_steering_control_scheme_params_pb.BeaconSteeringControlSchemeParams.serializeBinaryToWriter
    );
  }
  f = message.getTripodTrackingControlScheme();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      pbtypes_gen_skills_movement_tracking_control_scheme_params_pb.MovementTrackingControlSchemeParams.serializeBinaryToWriter
    );
  }
};


/**
 * optional sint32 version = 1;
 * @return {number}
 */
proto.skills.ControlSchemeParams.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.ControlSchemeParams} returns this
 */
proto.skills.ControlSchemeParams.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional GimbalPitchHandlerParams gimbal_pitch_handler = 2;
 * @return {?proto.skills.GimbalPitchHandlerParams}
 */
proto.skills.ControlSchemeParams.prototype.getGimbalPitchHandler = function() {
  return /** @type{?proto.skills.GimbalPitchHandlerParams} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_skills_gimbal_pitch_handler_params_pb.GimbalPitchHandlerParams, 2));
};


/**
 * @param {?proto.skills.GimbalPitchHandlerParams|undefined} value
 * @return {!proto.skills.ControlSchemeParams} returns this
*/
proto.skills.ControlSchemeParams.prototype.setGimbalPitchHandler = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.ControlSchemeParams} returns this
 */
proto.skills.ControlSchemeParams.prototype.clearGimbalPitchHandler = function() {
  return this.setGimbalPitchHandler(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.ControlSchemeParams.prototype.hasGimbalPitchHandler = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional PanTiltHandlerParams pan_tilt_handler = 3;
 * @return {?proto.skills.PanTiltHandlerParams}
 */
proto.skills.ControlSchemeParams.prototype.getPanTiltHandler = function() {
  return /** @type{?proto.skills.PanTiltHandlerParams} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_skills_pan_tilt_handler_params_pb.PanTiltHandlerParams, 3));
};


/**
 * @param {?proto.skills.PanTiltHandlerParams|undefined} value
 * @return {!proto.skills.ControlSchemeParams} returns this
*/
proto.skills.ControlSchemeParams.prototype.setPanTiltHandler = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.ControlSchemeParams} returns this
 */
proto.skills.ControlSchemeParams.prototype.clearPanTiltHandler = function() {
  return this.setPanTiltHandler(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.ControlSchemeParams.prototype.hasPanTiltHandler = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional SteeringJoystickHandlerParams steering_joystick_handler = 4;
 * @return {?proto.skills.SteeringJoystickHandlerParams}
 */
proto.skills.ControlSchemeParams.prototype.getSteeringJoystickHandler = function() {
  return /** @type{?proto.skills.SteeringJoystickHandlerParams} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_skills_steering_joystick_handler_params_pb.SteeringJoystickHandlerParams, 4));
};


/**
 * @param {?proto.skills.SteeringJoystickHandlerParams|undefined} value
 * @return {!proto.skills.ControlSchemeParams} returns this
*/
proto.skills.ControlSchemeParams.prototype.setSteeringJoystickHandler = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.ControlSchemeParams} returns this
 */
proto.skills.ControlSchemeParams.prototype.clearSteeringJoystickHandler = function() {
  return this.setSteeringJoystickHandler(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.ControlSchemeParams.prototype.hasSteeringJoystickHandler = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional GotoPointHandlerParams goto_point_handler = 5;
 * @return {?proto.skills.GotoPointHandlerParams}
 */
proto.skills.ControlSchemeParams.prototype.getGotoPointHandler = function() {
  return /** @type{?proto.skills.GotoPointHandlerParams} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_skills_goto_point_handler_params_pb.GotoPointHandlerParams, 5));
};


/**
 * @param {?proto.skills.GotoPointHandlerParams|undefined} value
 * @return {!proto.skills.ControlSchemeParams} returns this
*/
proto.skills.ControlSchemeParams.prototype.setGotoPointHandler = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.ControlSchemeParams} returns this
 */
proto.skills.ControlSchemeParams.prototype.clearGotoPointHandler = function() {
  return this.setGotoPointHandler(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.ControlSchemeParams.prototype.hasGotoPointHandler = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional JoysticksControlSchemeParams joysticks_control_scheme = 10;
 * @return {?proto.skills.JoysticksControlSchemeParams}
 */
proto.skills.ControlSchemeParams.prototype.getJoysticksControlScheme = function() {
  return /** @type{?proto.skills.JoysticksControlSchemeParams} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_skills_joysticks_control_scheme_params_pb.JoysticksControlSchemeParams, 10));
};


/**
 * @param {?proto.skills.JoysticksControlSchemeParams|undefined} value
 * @return {!proto.skills.ControlSchemeParams} returns this
*/
proto.skills.ControlSchemeParams.prototype.setJoysticksControlScheme = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.ControlSchemeParams} returns this
 */
proto.skills.ControlSchemeParams.prototype.clearJoysticksControlScheme = function() {
  return this.setJoysticksControlScheme(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.ControlSchemeParams.prototype.hasJoysticksControlScheme = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional SteeringControlSchemeParams steering_control_scheme = 11;
 * @return {?proto.skills.SteeringControlSchemeParams}
 */
proto.skills.ControlSchemeParams.prototype.getSteeringControlScheme = function() {
  return /** @type{?proto.skills.SteeringControlSchemeParams} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_skills_steering_control_scheme_params_pb.SteeringControlSchemeParams, 11));
};


/**
 * @param {?proto.skills.SteeringControlSchemeParams|undefined} value
 * @return {!proto.skills.ControlSchemeParams} returns this
*/
proto.skills.ControlSchemeParams.prototype.setSteeringControlScheme = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.ControlSchemeParams} returns this
 */
proto.skills.ControlSchemeParams.prototype.clearSteeringControlScheme = function() {
  return this.setSteeringControlScheme(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.ControlSchemeParams.prototype.hasSteeringControlScheme = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional TapToFlyControlSchemeParams tap_to_fly_control_scheme = 12;
 * @return {?proto.skills.TapToFlyControlSchemeParams}
 */
proto.skills.ControlSchemeParams.prototype.getTapToFlyControlScheme = function() {
  return /** @type{?proto.skills.TapToFlyControlSchemeParams} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_skills_tap_to_fly_control_scheme_params_pb.TapToFlyControlSchemeParams, 12));
};


/**
 * @param {?proto.skills.TapToFlyControlSchemeParams|undefined} value
 * @return {!proto.skills.ControlSchemeParams} returns this
*/
proto.skills.ControlSchemeParams.prototype.setTapToFlyControlScheme = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.ControlSchemeParams} returns this
 */
proto.skills.ControlSchemeParams.prototype.clearTapToFlyControlScheme = function() {
  return this.setTapToFlyControlScheme(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.ControlSchemeParams.prototype.hasTapToFlyControlScheme = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional StandardTrackingControlSchemeParams standard_tracking_control_scheme = 13;
 * @return {?proto.skills.StandardTrackingControlSchemeParams}
 */
proto.skills.ControlSchemeParams.prototype.getStandardTrackingControlScheme = function() {
  return /** @type{?proto.skills.StandardTrackingControlSchemeParams} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_skills_standard_tracking_control_scheme_params_pb.StandardTrackingControlSchemeParams, 13));
};


/**
 * @param {?proto.skills.StandardTrackingControlSchemeParams|undefined} value
 * @return {!proto.skills.ControlSchemeParams} returns this
*/
proto.skills.ControlSchemeParams.prototype.setStandardTrackingControlScheme = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.ControlSchemeParams} returns this
 */
proto.skills.ControlSchemeParams.prototype.clearStandardTrackingControlScheme = function() {
  return this.setStandardTrackingControlScheme(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.ControlSchemeParams.prototype.hasStandardTrackingControlScheme = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional MovementTrackingControlSchemeParams movement_tracking_control_scheme = 14;
 * @return {?proto.skills.MovementTrackingControlSchemeParams}
 */
proto.skills.ControlSchemeParams.prototype.getMovementTrackingControlScheme = function() {
  return /** @type{?proto.skills.MovementTrackingControlSchemeParams} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_skills_movement_tracking_control_scheme_params_pb.MovementTrackingControlSchemeParams, 14));
};


/**
 * @param {?proto.skills.MovementTrackingControlSchemeParams|undefined} value
 * @return {!proto.skills.ControlSchemeParams} returns this
*/
proto.skills.ControlSchemeParams.prototype.setMovementTrackingControlScheme = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.ControlSchemeParams} returns this
 */
proto.skills.ControlSchemeParams.prototype.clearMovementTrackingControlScheme = function() {
  return this.setMovementTrackingControlScheme(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.ControlSchemeParams.prototype.hasMovementTrackingControlScheme = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional HoverControlSchemeParams hover_control_scheme = 15;
 * @return {?proto.skills.HoverControlSchemeParams}
 */
proto.skills.ControlSchemeParams.prototype.getHoverControlScheme = function() {
  return /** @type{?proto.skills.HoverControlSchemeParams} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_skills_hover_control_scheme_params_pb.HoverControlSchemeParams, 15));
};


/**
 * @param {?proto.skills.HoverControlSchemeParams|undefined} value
 * @return {!proto.skills.ControlSchemeParams} returns this
*/
proto.skills.ControlSchemeParams.prototype.setHoverControlScheme = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.ControlSchemeParams} returns this
 */
proto.skills.ControlSchemeParams.prototype.clearHoverControlScheme = function() {
  return this.setHoverControlScheme(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.ControlSchemeParams.prototype.hasHoverControlScheme = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional BeaconSteeringControlSchemeParams beacon_steering_control_scheme = 16;
 * @return {?proto.skills.BeaconSteeringControlSchemeParams}
 */
proto.skills.ControlSchemeParams.prototype.getBeaconSteeringControlScheme = function() {
  return /** @type{?proto.skills.BeaconSteeringControlSchemeParams} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_skills_beacon_steering_control_scheme_params_pb.BeaconSteeringControlSchemeParams, 16));
};


/**
 * @param {?proto.skills.BeaconSteeringControlSchemeParams|undefined} value
 * @return {!proto.skills.ControlSchemeParams} returns this
*/
proto.skills.ControlSchemeParams.prototype.setBeaconSteeringControlScheme = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.ControlSchemeParams} returns this
 */
proto.skills.ControlSchemeParams.prototype.clearBeaconSteeringControlScheme = function() {
  return this.setBeaconSteeringControlScheme(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.ControlSchemeParams.prototype.hasBeaconSteeringControlScheme = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional MovementTrackingControlSchemeParams tripod_tracking_control_scheme = 17;
 * @return {?proto.skills.MovementTrackingControlSchemeParams}
 */
proto.skills.ControlSchemeParams.prototype.getTripodTrackingControlScheme = function() {
  return /** @type{?proto.skills.MovementTrackingControlSchemeParams} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_skills_movement_tracking_control_scheme_params_pb.MovementTrackingControlSchemeParams, 17));
};


/**
 * @param {?proto.skills.MovementTrackingControlSchemeParams|undefined} value
 * @return {!proto.skills.ControlSchemeParams} returns this
*/
proto.skills.ControlSchemeParams.prototype.setTripodTrackingControlScheme = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.ControlSchemeParams} returns this
 */
proto.skills.ControlSchemeParams.prototype.clearTripodTrackingControlScheme = function() {
  return this.setTripodTrackingControlScheme(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.ControlSchemeParams.prototype.hasTripodTrackingControlScheme = function() {
  return jspb.Message.getField(this, 17) != null;
};


goog.object.extend(exports, proto.skills);
